import { render, staticRenderFns } from "./FilterSelectorController.vue?vue&type=template&id=5980409a&scoped=true"
import script from "./FilterSelectorController.vue?vue&type=script&lang=js"
export * from "./FilterSelectorController.vue?vue&type=script&lang=js"
import style0 from "./FilterSelectorController.vue?vue&type=style&index=0&id=5980409a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980409a",
  null
  
)

export default component.exports